import Vue from 'vue'
import Router from 'vue-router'

import { store } from '../main.js'

import Home from './home'
import Login from './login'
import User from './user'
import Profile from './profile'
import Vehicle from './vehicle'
import Indicators from './indicators'
import Holidays from './holidays'
import ReserveVehicles from './reserveVehicles'
import ReserveModeration from './reserveModeration'
import RequestsHistory from './rqHistory'
import Parameters from './parameters'
import Exportation from './exportation'
import VehicleStatus from './vehicleStatus'
import VehicleTypes from './vehicleType'
import Branches from './branch'
import Category from './category'
import Department from './department'
import Justification from './justification'
import Divergences from './divergences'
import Color from './color'
import CityDestination from './cityDestination'
import NextTrips from './next_trips'
import NextTripsWebview from './next_trips_webview'
import Regionals from './regional'
import AccessLog from "./access-log";
import CostCenter from "./cost-center";
import NetworkDiagram from "./network-diagram";
import ChecklistItems from "./checklist-items";
import BreakdownTypes from "./breakdown-types";
import Report from "./report";
import Log from "./log";
import IntegrationLogs from "./integration-logs";
import ApiErrorLogs from "./api-error-logs";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    linkActiveClass: "active",
    hashbang: false,
    routes: [
        Login,
        Home,
        User,
        Profile,
        Vehicle,
        Indicators,
        Holidays,
        ReserveVehicles,
        RequestsHistory,
        ReserveModeration,
        VehicleStatus,
        Parameters,
        Exportation,
        VehicleTypes,
        Category,
        Branches,
        Department,
        Justification,
        Divergences,
        Color,
        CityDestination,
        NextTrips,
        NextTripsWebview,
        Regionals,
        AccessLog,
        CostCenter,
        NetworkDiagram,
        ChecklistItems,
        BreakdownTypes,
        Report,
        Log,
        IntegrationLogs,
        ApiErrorLogs
    ],
    scrollBehavior() {
        document.getElementById('app').scrollIntoView();
    }
});

router.beforeEach((to, from, next) => {
    const terms = localStorage.getItem('accept_terms');

    const authenticated = localStorage.getItem('token');

    let to_splited = to.path.toString().split('/')
    to_splited = to_splited.filter(part => part !== '')

    if (
        !authenticated &&
        (
            !(['/login'].includes(to.path.toString())) &&
            !(['login-by-token'].includes(to_splited[0])) &&
            !(['next-trips-webview'].includes(to_splited[0]))
        )
    ) {
        next('/login');

        return true;
    }

    if (authenticated && to.path.toString() == '/login') {
        next('/');

        return true;
    }

    if (authenticated && to.path.toString() != '/profile/accept_terms' && terms == 0) {
        next('/profile/accept_terms');

        return true;
    }

    // if (terms && to.path.toString() != '/login') {
    //     next('/departments');

    //     return true;
    // }

    next();
});



router.afterEach((to, from) => {
    let _name = to.name;
    let _route = to.fullPath;

    if (_name === 'Home') {
        _name = '';
        _route = '';
    }

    store.commit("updateBreadCrumbs", { name: _name, route: _route })
});


export default router



// WEBPACK FOOTER //
// ./src/router/index.js